import React from 'react';

export default function ReleaseBalances() {
  return (
    <div className="rounded border-1 p-4 my-4 flex justify-between">
      <div>TODO ReleaseBalances</div>
    </div>
  );
}
